import { PickupCorporateConfigApiRepository } from "@/app/infrastructures/repositories/api/PickupCorporateConfigApiRepository";
import { PickupCorporateConfig } from "@/domain/entities/PickupCorporateConfig";
import { injectable } from "tsyringe";

@injectable()
export class PickupCorporateConfigPresenter {
  constructor(private repository: PickupCorporateConfigApiRepository) {}

  public getConfig(): Promise<PickupCorporateConfig> {
    return this.repository.getConfig();
  }
}
